import { render, staticRenderFns } from "./AddShuttleFile.vue?vue&type=template&id=4aceab9a&scoped=true"
import script from "./AddShuttleFile.vue?vue&type=script&lang=js"
export * from "./AddShuttleFile.vue?vue&type=script&lang=js"
import style0 from "./AddShuttleFile.vue?vue&type=style&index=0&id=4aceab9a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aceab9a",
  null
  
)

export default component.exports